import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { ContentManagement } from '../modal';

export default function reducer(state: ContentManagement = new ContentManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.CONTENT_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.CONTENT_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.CONTENT_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
